import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import AfkPipeline from './AfkPipeline';
import BookAssessment from './BookAssessment';

const AfkPipelineSection = () => (
  <div id="afk-pipeline" className="border-y border-gray-800 bg-gray-950 py-20">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="max-w-measure">
        <p className="font-mono text-eyebrow uppercase text-accent-400">AFK Development</p>
        <h2 className="mt-4 font-display text-display-md font-bold text-white sm:text-display-lg">
          Humans at both ends. Agents in the middle.
        </h2>
        <p className="mt-4 text-lg text-gray-300">
          Away-from-keyboard development, stage by stage. Every constraint here exists because of a
          failure it prevents. That is the whole design.
        </p>
      </div>

      <AfkPipeline className="mt-14" />

      <p className="mt-12 max-w-measure text-gray-400">
        One honest constraint: run as many pipelines as your review capacity can absorb, and no more.
        The bottleneck moves to human judgment. That is where it belongs.
      </p>

      <div className="mt-8 flex flex-col gap-x-8 gap-y-3 sm:flex-row sm:items-start">
        <BookAssessment placement="afk-section" variant="bare" band="gray-950" />
        <Link
          to="/afk-development"
          className="inline-flex min-h-[44px] items-center py-2.5 font-medium text-accent-400 transition-colors duration-150 hover:text-accent-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-400"
        >
          Read the full pipeline <ArrowRight className="ml-1 h-4 w-4" aria-hidden="true" />
        </Link>
      </div>
    </div>
  </div>
);

export default AfkPipelineSection;
